var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tagNode
    ? _c(
        "div",
        [
          _c(
            "h2",
            [
              _vm._l(_vm.tagNode.ancestors, function (ancestor) {
                return _c(
                  "span",
                  { key: ancestor.id, staticStyle: { "font-size": "14px" } },
                  [_vm._v(_vm._s(ancestor.name) + " > ")]
                )
              }),
              _vm._v(_vm._s(_vm.tagNode.name)),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.tagNode.talent, function (talent) {
                return _c("li", { key: talent.id }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedTalent,
                        expression: "selectedTalent",
                      },
                    ],
                    attrs: {
                      id: "talent-checkbox-" + talent.id,
                      type: "checkbox",
                    },
                    domProps: {
                      value: talent.id,
                      checked: Array.isArray(_vm.selectedTalent)
                        ? _vm._i(_vm.selectedTalent, talent.id) > -1
                        : _vm.selectedTalent,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.selectedTalent,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = talent.id,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selectedTalent = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedTalent = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedTalent = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "talent-checkbox-" + talent.id } },
                    [_vm._v(_vm._s(talent.name))]
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", [
              _vm.selectedTalent.length
                ? _c("div", [
                    _vm._v(
                      _vm._s(_vm.selectedTalent.length) + " stars selected"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  attrs: { disabled: !_vm.selectedTalent.length },
                  on: {
                    click: () => {
                      this.searching = !this.searching
                    },
                  },
                },
                [_c("i", { staticClass: "fa fa-share" }), _vm._v(" Move")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  attrs: { disabled: !_vm.selectedTalent.length },
                  on: { click: _vm.deleteTalent },
                },
                [_c("i", { staticClass: "fa fa-trash" }), _vm._v(" Delete")]
              ),
              _vm._v(" "),
              _vm.searching
                ? _c(
                    "div",
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchString,
                            expression: "searchString",
                          },
                        ],
                        domProps: { value: _vm.searchString },
                        on: {
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.searchNodes.apply(null, arguments)
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.searchString = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("button", { on: { click: _vm.searchNodes } }, [
                        _c("i", { staticClass: "fa fa-search" }),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.searchResults, function (result) {
                        return _c("div", { key: result.id }, [
                          _c(
                            "div",
                            { staticClass: "flex" },
                            [
                              _vm._l(result.ancestors, function (ancestor) {
                                return _c(
                                  "span",
                                  {
                                    key: ancestor.id,
                                    staticStyle: { "font-size": "12px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(ancestor.name) +
                                        " >\n          "
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(result.name) +
                                  "\n          "
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              on: {
                                click: () => {
                                  _vm.moveTalent(result.id)
                                },
                              },
                            },
                            [_c("i", { staticClass: "fa fa-mail-forward" })]
                          ),
                        ])
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("system-tag-node-add-talent-modal", {
            on: {
              add: (selected) => {
                this.addTalent(selected)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex justify-between" }, [
      _c("h3", [_vm._v("Stars")]),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: {
            "data-toggle": "modal",
            "data-target": "#modal-tag-node-add-talent",
            "data-backdrop": "static",
          },
        },
        [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }